import { render, staticRenderFns } from "./referral.vue?vue&type=template&id=170bd072&scoped=true"
import script from "./referral.vue?vue&type=script&lang=js"
export * from "./referral.vue?vue&type=script&lang=js"
import style0 from "./referral.vue?vue&type=style&index=0&id=170bd072&prod&lang=css"
import style1 from "./referral.vue?vue&type=style&index=1&id=170bd072&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170bd072",
  null
  
)

export default component.exports